import React from 'react';
import { site } from '../data/siteData';

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '20px' }}>
        <div>
          <div style={{ fontWeight: '600', color: 'var(--text)', marginBottom: '4px' }}>{site.brand.name}</div>
          <div className="muted">© {year} · Built with React</div>
        </div>
        <div style={{ display: 'flex', gap: '16px' }}>
          <a href={site.brand.links.linkedin} target="_blank" rel="noopener noreferrer" className="socialLink">LinkedIn</a>
          <a href={`mailto:${site.brand.email}`}>Email</a>
        </div>
      </div>
    </footer>
  );
}
